import React, { memo } from 'react'
import { BountyCountStyled, BountyCountWrapper } from './BountyContent.styled'

export interface BountyCountProps {
  count?: number | null
  disabled?: boolean
  showOnlyInfo?: boolean
  availableBountiesCount?: boolean
}

const BountyCount = ({ count, disabled, showOnlyInfo }: BountyCountProps) => {
  if (!count || disabled || showOnlyInfo)
    return (
      <BountyCountWrapper>
        <BountyCountStyled></BountyCountStyled>
      </BountyCountWrapper>
    )

  return (
    <BountyCountWrapper>
      <BountyCountStyled>[{count} LEFT]</BountyCountStyled>
    </BountyCountWrapper>
  )
}

export default memo(BountyCount)
